import { Fragment } from 'react';

import { FormattedMessage } from 'react-intl';

import { PageWrapper } from 'modules/layout';

import AddNewsForm from '../../containers/AddNewsForm';

const AddNewsPage = () => (
    <PageWrapper
        header={
            <Fragment>
                <FormattedMessage id="news.add.title" />
            </Fragment>
        }
    >
        <AddNewsForm delayed />
    </PageWrapper>
);

export default AddNewsPage;
